export const order = 1;
export const routes = {
  path: "/",
  name: "learningInputLayout",
  component: () => import("@/views/layout"),
  meta: {
    title: "学习录入",
    guard: {
      role: ["Admin"],
      permission: ["upms:learningInput"],
    },
  },
  children: [
    {
      path: "learningInputPage",
      name: "learningInputPage",
      component: () => import("@/views/learningInput"),
      meta: {
        title: "学习录入",
        guard: {
          role: ["Admin"],
          permission: ["upms:learningInputPage"],
        },
      },
    },
  ],
};
export const perms = {};
